<template>
    <a-card :title="$t('screenTitle.charGameFunc')">
        <a-form :model="formModel" @finish="onFinish" :rules="formRule" :scrollToFirstError="true" layout="vertical">
            <a-form-item label="Máy chủ" name="server_id">
                <ServerSelectView v-model="formModel.server_id" @update:model-value="getServerChars" />
            </a-form-item>

            <a-form-item label="Nhân vật" name="charguid">
                <a-select :disabled="!formModel.server_id || !optionsChars.length" v-model:value="formModel.charguid" :options="optionsChars" />
            </a-form-item>

            <a-form-item label="Chức năng" name="game_func">
                <a-select v-model:value="formModel.game_func" :options="optionsGameFuncs" />
            </a-form-item>

            <a-form-item>
                <a-button type="primary" html-type="submit" block :loading="isLoading">{{ $t('text.process') }}
                </a-button>
            </a-form-item>
        </a-form>
    </a-card>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, } from 'vue';
import { useI18n } from 'vue-i18n';

import { Button, Card, Form, message, Select, } from 'ant-design-vue';
import { RuleObject } from 'ant-design-vue/lib/form';
import { OptionType } from 'ant-design-vue/lib/select';

import ApiRequest from '@/utils/ApiRequest';
import ServerSelectView from '@/components/ServerSelectView.vue';
// import { useStore } from 'vuex';
import { viscii2utf8 } from '@/utils/helpers';
import { menpaiName } from '@/utils/TCharInfo';

enum GameFunc {
    RESET_EXP = 1,
    UNLOCK_CHAR,
}

interface FormModel {
    server_id?: number;
    charguid?: number;
    game_func?: GameFunc;
}

export default defineComponent({
    components: {
        ACard: Card,
        AButton: Button,
        AForm: Form,
        AFormItem: Form.Item,
        ASelect: Select,

        ServerSelectView,
    },

    setup() {
        const { t } = useI18n();
        // const store = useStore();
        // const userInfo = computed(() => store.getters.user);

        const optionsGameFuncs = [
            {
                value: GameFunc.RESET_EXP,
                label: 'Reset EXP',
            },
            {
                value: GameFunc.UNLOCK_CHAR,
                label: 'Mở khoá nhân vật',
            },
        ];
        const optionsChars = ref<OptionType[]>([]);
        const isLoading = ref(false);
        const formModel = reactive<FormModel>({
            server_id: undefined,
            charguid: undefined,
            game_func: undefined,
        });
        const formRule = reactive<Record<keyof FormModel, RuleObject[]>>({
            server_id: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                }
            ],
            charguid: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                }
            ],
            game_func: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                }
            ],
        });
        const onFinish = (values: FormModel) => {
            isLoading.value = true;

            let gameFuncUrl;

            switch (values.game_func) {
                case GameFunc.RESET_EXP:
                    gameFuncUrl = '/reset-fatigue';
                    break;
                case GameFunc.UNLOCK_CHAR:
                    gameFuncUrl = '/unlock';
                    break;
            }

            ApiRequest.post(`/servers/${values.server_id}/chars/${values.charguid}/${gameFuncUrl}`).then(() => {
                message.success(t('message.updateSuccess'));
            })
                .finally(() => {
                    isLoading.value = false;
                });
        };
        const getServerChars = (serverId: number) => {
            formModel.charguid = undefined;

            if (!serverId) {
                return;
            }

            optionsChars.value = [];
            ApiRequest.get(`/servers/${serverId}/chars`).then(({ data }) => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                optionsChars.value = data.data.map((v:any) => ({
                    value: v.charguid,
                    label: `${viscii2utf8(v.charname)} [${menpaiName(v.menpai)}] (${v.level}) - ${v.charguid.toString(16).toUpperCase()}`,
                }));
            })
        };

        return {
            isLoading,
            formModel,
            formRule,
            onFinish,
            optionsChars,
            optionsGameFuncs,
            getServerChars,
        };
    },
});
</script>
